import { useState } from "react";
import { _put } from "../../../libraries/fetch";
import { syncAllMembersURL } from "../../../libraries/apiUrl";

export default function SyncAllMembers({ branchId, branchName }) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [confirmPopupOpen, setConfirmPopupOpen] = useState(false);
  const [successPopupOpen, setSuccessPopupOpen] = useState(false);

  const handleSyncAll = () => {
    setConfirmPopupOpen(true);
  };

  const confirmSyncAll = () => {
    if (!branchId) {
      setMessage("Branch is not loaded yet. Try again in a moment.");
      setConfirmPopupOpen(false);
      return;
    }
    setMessage(null);
    setConfirmPopupOpen(false);
    setSuccessPopupOpen(false);
    setLoading(true);
    _put(syncAllMembersURL(branchId), {})
      .then((res) => {
        if (res && res.status === true) {
          setSuccessPopupOpen(true);
          return;
        }
        if (res && res.success !== false) {
          setMessage(res.message || "Sync completed.");
        } else {
          setMessage(res?.message || "Sync could not be completed.");
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <div style={{ padding: "24px 20px", maxWidth: 560 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
          marginBottom: 16
        }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: "1.25rem", fontWeight: 600 }}>Sync All Members</h2>
          <p style={{ margin: "6px 0 0", color: "#d1d5db", fontSize: "0.95rem" }}>
            Branch Name: {branchName || "Loading..."}
          </p>
        </div>
        <button
          type="button"
          onClick={handleSyncAll}
          disabled={loading || !branchId}
          style={{
            padding: "12px 22px",
            borderRadius: "8px",
            border: "1px solid #187718",
            background: loading || !branchId ? "#3b3f47" : "#187718",
            color: "#fff",
            fontWeight: 600,
            cursor: loading || !branchId ? "not-allowed" : "pointer",
            opacity: loading || !branchId ? 0.7 : 1
          }}
        >
          {loading ? "Syncing..." : "Sync All Members"}
        </button>
      </div>
      <p style={{ margin: "0 0 20px", color: "#9ca3af", lineHeight: 1.5 }}>
        Trigger a full member sync for this branch. This may take a while depending on member count.
      </p>
      {message && (
        <p style={{ marginTop: "16px", color: "#e5e7eb", fontSize: "0.95rem" }} role="status">
          {message}
        </p>
      )}

      {confirmPopupOpen && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="sync-confirm-title"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.55)",
            padding: 16,
          }}
          onClick={() => setConfirmPopupOpen(false)}
        >
          <div
            style={{
              background: "#1f2937",
              border: "1px solid #374151",
              borderRadius: 12,
              padding: "24px 28px",
              maxWidth: 400,
              width: "100%",
              boxShadow: "0 20px 50px rgba(0,0,0,0.45)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 id="sync-confirm-title" style={{ margin: "0 0 12px", fontSize: "1.1rem", fontWeight: 600, color: "#f9fafb" }}>
              Confirmation
            </h3>
            <p style={{ margin: "0 0 20px", color: "#d1d5db", lineHeight: 1.5, fontSize: "0.95rem" }}>
              Are you sure you want to sync all members?
            </p>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                type="button"
                onClick={() => setConfirmPopupOpen(false)}
                style={{
                  padding: "10px 20px",
                  borderRadius: 8,
                  border: "1px solid #4b5563",
                  background: "#374151",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                No
              </button>
              <button
                type="button"
                onClick={confirmSyncAll}
                style={{
                  padding: "10px 20px",
                  borderRadius: 8,
                  border: "none",
                  background: "#187718",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {successPopupOpen && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="sync-success-title"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.55)",
            padding: 16,
          }}
          onClick={() => setSuccessPopupOpen(false)}
        >
          <div
            style={{
              background: "#1f2937",
              border: "1px solid #374151",
              borderRadius: 12,
              padding: "24px 28px",
              maxWidth: 400,
              width: "100%",
              boxShadow: "0 20px 50px rgba(0,0,0,0.45)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 id="sync-success-title" style={{ margin: "0 0 12px", fontSize: "1.1rem", fontWeight: 600, color: "#f9fafb" }}>
              Success
            </h3>
            <p style={{ margin: "0 0 20px", color: "#d1d5db", lineHeight: 1.5, fontSize: "0.95rem" }}>
              All members synced successfully
            </p>
            <button
              type="button"
              onClick={() => setSuccessPopupOpen(false)}
              style={{
                padding: "10px 20px",
                borderRadius: 8,
                border: "none",
                background: "#187718",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
                width: "100%",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
